import { Link } from "@/atoms"

import type { ScanHistory } from "@/domain/scan-history"

export const PrCell = (value: string, record: ScanHistory) => (
  <Link target="_blank" href={record.refUrl}>
    {value}
  </Link>
)
